import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'

export const alertsSelector = state => state.alertEntities.alerts

const ReduxProvider = ({ alerts, children }) => <React.Fragment>{children(alerts)}</React.Fragment>

export default compose(
  connect(state => ({
    alerts: alertsSelector(state).toList().toJS(),
  }))
)(ReduxProvider)
